import React from "react";
import { Grid } from "@mui/material";
import MainTitle from "../../muiHome/mainTitle";
import FacultyCard from "../../muiCommonComponent/facultyCards";

const FacultyList=()=>{
    const facultyList=[
      {img:'/assets/img/SOPS/ashutoshupadhayay.jpg',
        name:'Dr. Ashutosh Upadhayay',
        position:'Professor & Dean',
        email:'dr.ashutoshupadhayay@mvn.edu.in',
            gs: "https://scholar.googleh.com/citations?user=h3LRiD0AAAAJ&hl=en&authuser=1 ",
            linkedin: "",
            orcid: "https://orcid.org/0009-0002-8848-2149",
            rg: "https://www.researchgate.net/profile/Ashutosh-Upadhayay-2 ",
            website: "#",
            aoi: "Clinical Research, Antidiabetic, Anti-hyperlipidemic, Toxicology",
            education: "PhD (Pharmacology)",
            re: "1",
            te: "18",
            iece: ".02",
            articles:
              "<li>1.	Correlation between demographic characteristics and degree of illness among asthmatic patients in the panchkula region, European Chemical Bulletin, 2023 12 (special issue 5), 4868-4874.  </li> <li>2.	Clinical trials in Pharmacy: Methodology and Ethics considerations, European Chemical Bulletin, 2023 (special issue 9)2971-2983  </li> <li>3.	A review on comparison of allopathic medicines to other drug therapies in the management of asthama, Infect Disord Drug targets, 24(2);2024, Article ID: e201023222496  </li><li>4.	The influence of Phytoconstituents for the management of antipsoriatic activity in various animal models, Anti-inflamma. & Anti-allerg. Agents in Med. Chem ,07;2024 DOI: 10.2174/0118715230320581240711063558  </li>",
            books:
              "<li>1.	A Text book of Pharmaceutical Jurisprudence, Nitya Publication, Bhopal, MP, India. ISBN: 9789394894495 </li><li>2.	A practical book of Pharmacology- II, TDC Publication, Gurugram, Haryana, India. ISBN: 9789391864705</li>",
            chapters:
              "<li>NA</li>",
            patents:
              "<li>Polyherbal formulation for wound healing and a process for the preparation there of Appl. No. 202311004263A, Issue No. 4/2023, publication date 27/01/2023</li>",
            membership:
              "<li> i.	Life Member, Association of the Pharmaceutical Teachers of India (APTI). </li><li>ii.	Registered Pharmacist of Rajasthan pharmacy council. </li><li> iii.	Life member, Indian Pharmacy Graduate Association (IPGA) </li>",
            aa1: "1.	Awarded by APP Best Teacher Award 2014 in National seminar (FPER: GC2014) November 16, 2014 at Alwar Pharmacy College, Alwar ",
            aa2: "2.	Awarded by Best Teacher Award 2022 for outstanding achievement in NIMS University",
            aa3: "3.	Conducted Pre conference workshop on ‘Hands on training on ADR reporting’ organized by NIMS institute of pharmacy, NIMS university, Jaipur on dated 25th November 2022 as a registration in-charge. ",
            aa4: "4.	Conducted International conference on ‘Fostering high quality clinical research for a healthier world” organised by NIMS institute of pharmacy, NIMS university, Jaipur on dated 26 november 2022 registration in-charge.  ",
            aa5: "5.	Conducted Workshop-cum hands on practice on “Artificial intelligence in new molecular discoveries” as a organizing secretary (A part of social scientific responsibility activity of SERB project) organised by center of inter-dicilplinary biomedical research (CIBR), Adesh university, bathinda, punjab on dated 27-29 april 2023.",
            aa6: "6.	Conducted 3rd International Conference on “Recent Advancements and Innovations in Healthcare.” as a organizing secretary & Registration Incharge (IPGA), at MVN University, Palwal, Haryana on dated 15th  Nov. 2024.",
            about:  "<p>He served as various academic positions at the level of Lecturer, Assistant Professor, Associate Professor and Professor in different colleges. Prof. Upadhayay has been associated with Quality Pharmacy Education as an academician since 20 yrs. Presently, he is serving as a Professor & Dean, MVN University, Palwal, Haryana.</p><p>His research areas of interest are Modern methods of extraction techniques, Isolation and characterization of bioactive compound (s), Clinical research, Toxicological studies, Rational Use of drugs, Hepatotoxicity, Diabetes, Hyperlipidemic, behavioral studies and herbal drug technology.</p><p>He is recipient of prestigious Best Teacher Award in 2014, outstanding achievement in teaching Award in 2022, Best Researcher Award in 2023</p><p>He has guided various students for their M. Pharm and Ph.D. research studies. He has published</p><p>More than 50 research papers in International and National journals. He also published various books of pharmacy domain. He has also contributed in patents application and grants and has presented several research papers in scientific conferences. He has also organized various national and international conferences, Faculty Development programmes, seminars and workshops.</p><p>He is a life member of several associations like IPGA, APTI etc.</p>",
            },
      /*{
        img: '/assets/img/SAHS/faculty/biotech/vineet.jpg',
        name: 'Prof Vineet Kumar',
        position: 'Professor & Dean',
        email: 'drvineet.kumar@mvn.edu.in',
        gs: '',
        linkedin: 'https://www.linkedin.com/in/vineet-kumar-phd-52431111/',
        orcid: '0000-0003-2121-3964',
        rg: 'https://www.researchgate.net/profile/Vineet-Kumar-8?ev=hdr_xprf',
        website: '',
        aoi: 'Biotechnology, Neurobiology, Host-Pathogen interaction',
        education: 'PhD (Biomedical Sciences) DU, CRIS-NET-JRF',
        re: '16',
        te: '15',
        iece: '',
        articles: '12',
        books: 'N/A',
        chapters: '3',
        patents: 'N/A',
        membership: 'N/A',
        aa1: 'EMBO Travel grant award.   ',
        aa2: 'Erasmus Mundus EMW15 research award ',
        aa3: 'Qualified the CSIR-UGC conducted NET exam June 2002 and have become eligible for JRF-Fellowship under CSIR schemes and become eligible for lectureship ',
        aa4: 'Qualified the ICMR conducted ICMR-JRF exam July 2002 and have become eligible for JRF-Fellowship 5. Qualified the ICAR conducted ASR NET exam Oct 2001 and have become eligible for Lectureship in Biotechnology.',
        aa5: '',
        aa6: ''
      },*/
      {
        img: '/assets/img/SAHS/faculty/biotech/dheeman.jpg',
        name: 'Dr. Shrivardhan Dheeman',
        position: 'Associate Professor & Associate Dean school of Allied Health Sciences',
        email: 'shrivardhan.dheeman@mvn.edu.in; svdheeman@gmail.com',
        gs: '',
        linkedin: 'https://www.linkedin.com/in/sdheeman/',
        orcid: 'https://orcid.org/0000-0001-6879-8635',
        rg: 'https://www.researchgate.net/profile/Shrivardhan-Dheeman',
        website: 'https://sdheeman.in/',
        aoi: 'Plant Microbe Interaction, Rhizosphere Microbiology, Sustainable Agriculture',
        education: 'M.Sc., Ph.D. (Microbiology)',
        re: '13',
        te: '9',
        iece: '1',
        articles: '15',
        books: '6',
        chapters: '21',
        patents: '1',
        membership: ' <li>Member Secretary, BOS, School of Allied Health Sciences, MVN University, Palwal -NCR, Haryana, India</li><li>External Examiner, J.C. Bose University of Technology (YMCA), Faridabad, India</li><li>Member, Board of Studies, Department of Microbiology, Sardar Bhagwan Singh University, Dehradun, India</li><li>External Examiner, Department of Microbiology, Sri Ras Bihari Bose Subharti University, Dehradun, India</li><li>External Member, Board of Studies, Department of Microbiology, Sri Dev Suman University, Tehri, Uttarakhand, India</li><li>Member, Board of Studies, Department of Agriculture, Sardar Bhagwan Singh University, Dehradun, India</li><li>Life Member, Indian Science Congress Association, Kolkata, India</li><li>Life Member, Asian PGPR Society for Sustainable Agriculture</li><li>Life Member, Microbiologist Society of India, India</li>',
        aa1: 'Selected in the Category of Young Scientist during 103rd Indian Science Congress, 2016',
        aa2: 'Best Judge Luminescence - STEAM FEST 2024 at Modern Vidya Niketan Sr. Sec. School, Sector-17, Faridabad during 31/08/2024',
        aa3: 'Best Judge WEBCRAFT in the Inter School Technological Extravaganza - TECHBLITZ 2024 at MVN Aravali Hills, Faridabad during 20/07/2024',
        aa4: 'Member Secretary, BOS, School of Allied Health Sciences, MVN University, Palwal -NCR, Haryana, India',
        aa5: 'External Examiner, J.C. Bose University of Technology (YMCA), Faridabad, India',
        aa6: 'Member, Board of Studies, Department of Microbiology, Sardar Bhagwan Singh University, Dehradun, India'
      },
      /*{
        img: '/assets/img/SAHS/faculty/dr_ashish_chauhan.jpg',
        name: 'Dr. Ashish Chauhan',
        position: 'Associate Professor & Head',
        email: 'hodbpt@mvn.edu.in',
        gs: '',
        linkedin: 'https://www.linkedin.com/public-profile/settings?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_self_edit_contact-info%3BGoxNJfdJRb%2BbQV5fi8dQyg%3D%3D',
        orcid: 'https://orcid.org/0009-0000-8715-0551',
        rg: 'https://www.researchgate.net/profile/Shrivardhan-Dheeman',
        website: 'https://sdheeman.in/',
        aoi: 'Orthopedica & Its Conditions',
        education: 'PhD Scholar, Master in Physiotherapy(Orthopedics)',
        re: '1',
        te: '10',
        iece: '10',
        articles: '7',
        books: '',
        chapters: '2',
        patents: '1',
        membership: ' <li>2</li>',
        aa1: '4',
        aa2: '',
        aa3: '',
        aa4: '',
        aa5: '',
        aa6: ''
      },*/

      {
        img: '/assets/img/SAHS/faculty/Ashwani_Kumar_Sanghi.jpg',
        name: 'Dr Ashwani Kumar Sanghi',
        position: 'Professor',
        email: 'dr.ashwanikumarsanghi@mvn.edu.in',
        gs: '',
        linkedin: 'https://www.linkedin.com/in/ashwani-sanghi-a76a13266',
        orcid: '0009-0006-2619-1433',
        rg: '',
        website: '',
        aoi: 'Phytochemical Analysis & Protein purification',
        education: 'PhD (Biochemistry) ',
        re: '5',
        te: '17',
        iece: '',
        articles: '25',
        books: 'N/A',
        chapters: '2',
        patents: '2',
        membership: 'N/A',
        aa1: 'N/A',
        aa2: '',
        aa3: '',
        aa4: '',
        aa5: '',
        aa6: ''
      },{
    img: '/assets/img/SAHS/faculty/ravindra_nath.jpg',
    name: 'Dr. Ravindra Nath',
    position: 'Visiting Professor',
    email: 'dr.ravindranath@mvn.edu.in',
    gs: '',
    linkedin: 'linkedin.com/in/dr-ravindra-nath-97268225',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'Moleculer Biolody & Analytical techs.',
    education: 'Ph.D. ',
    re: '17 ',
    te: '4',
    iece: 'NA',
    articles: '10',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: 'N/A',
    aa1: 'Life time membership of Indian Society for the Study of reproduction and Fertility (ISSRF)',
    aa2: 'National: Life time membership of Bio-Electromagnetic Society if India (BESI) ',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  
      {
        img: '/assets/img/SAHS/faculty/Swati _Chitranshi_AHS.jpg',
        name: 'Dr. Swati Chitranshi',
        position: 'Assistant Professor',
        email: 'swati.chitranshi@mvn.edu.in',
        gs: '',
        linkedin: '',
        orcid: '',
        rg: '',
        website: '',
        aoi: 'Microbial Metabolites',
        education: 'PhD (Microbiology) ',
        re: '7+',
        te: '5',
        iece: '',
        articles: '10',
        books: 'N/A',
        chapters: 'N/A',
        patents: 'N/A',
        membership: 'N/A',
        aa1: 'N/A',
        aa2: '',
        aa3: '',
        aa4: '',
        aa5: '',
        aa6: ''
      },
       {
    img: '/assets/img/SAHS/faculty/rajnish.jpg',
    name: 'Dr. Rajnish Kumar',
    position: 'Assistant Professor',
    email: 'rajnish.kumar@mvn.edu.in',
    gs: '',
    linkedin: 'www.linkedin.com/in/darshanpayla',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'Multiplex PCR, Food pathogens , AMR',
    education: 'Ph.D.(Biomedical Science), CSIR-NET-JRF',
    re: '5',
    te: '3+',
    iece: '',
    articles: '6',
    books: 'N/A',
    chapters: '2',
    patents: '3',
    membership: 'N/A',
    aa1: 'N/A',
    aa2: '',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/RitikaJaggi.jpg',
    name: 'Ms.Ritika Jaggi',
    position: 'Assistant professor',
    email: 'ritika.jaggi@mvn.edu.in',
    gs: '',
    linkedin: 'https://www.linkedin.com/in/ritika-jaggi-1092a21b2',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'Haematology , Histopathology and Microbiology ',
    education: 'BMLT, M.Sc Microbiology ',
    re: '2',
    te: '6',
    iece: '2',
    articles: '1',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: 'N/A',
    aa1: 'N/A',
    aa2: '',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/biotech/himani.jpg',
    name: 'Ms. Himani',
    position: 'Assistant Professor',
    email: 'himanirawat35@gmail.com',
    gs: '',
    linkedin: 'https://www.linkedin.com/in/himani-rawat-152b16214',
    orcid: 'https://orcid.org/0009-0008-3502-7111?lang=en',
    rg: 'https://www.researchgate.net/profile/Himani-Rawat-9?ev=hdr_xprf',
    website: '',
    aoi: 'Biotechnology, Microbiology, Molecular biology ',
    education: 'B.Sc, M.Sc ( Microbiology)',
    re: '',
    te: '4',
    iece: '1.5',
    articles: '1',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: 'N/A',
    aa1: 'N/A',
    aa2: '',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/Neeraj.jpg',
    name: 'Mr. Neeraj Bhardwaj',
    position: 'Assistant Professor',
    email: 'neeraj.bhardwaj@mvn.edu.in',
    gs: '',
    linkedin: 'https://www.linkedin.com/in/neeraj-bhardwaj-24a428219?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'Plant Tissue Culture, Molecular Biology Techniques,In Silico Study',
    education: 'M.Sc. Biotechnology',
    re: '1',
    te: '4',
    iece: '1',
    articles: '1',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: 'N/A',
    aa1: '',
    aa2: '',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  },
      {
        img: '/assets/img/SAHS/faculty/physio/sakshi.jpg',
        name: 'Dr. Sakshi Garg (PT)',
        position: 'Assistant Professor',
        email: 'sakshi.garg@mvn.edu.in',
        gs: '',
        linkedin: '',
        orcid: '',
        rg: '',
        website: '',
        aoi: 'CARDIAC & PULMONARY REHABILITATION',
        education: 'MPT (CARDIOPULMONARY)',
        re: '3+',
        te: '3+',
        iece: '',
        articles: '4',
        books: 'N/A',
        chapters: '1',
        patents: 'N/A',
        membership: '<li>REGISTERED IN HARYANA STATE COUNCIL OF PHYSIOTHERAPY</li>',
        aa1: '',
        aa2: '',
        aa3: '',
        aa4: '',
        aa5: '',
        aa6: ''
      },
  {
    img: '/assets/img/SAHS/faculty/physio/divya.jpg',
    name: 'Dr. Divya Singh (PT)',
    position: 'Assistant Professor',
    email: 'divya.singh@mvn.edu.in',
    gs: '',
    linkedin: '-',
    orcid: '0009-0008-8438-8861',
    rg: '-',
    website: '',
    aoi: 'Neurology',
    education: 'MPT (Neurology)',
    re: '2',
    te: '2',
    iece: '4',
    articles: '1',
    books: '-',
    chapters: '-',
    patents: '-',
    membership: '<li>REGISTERED IN HARYANA STATE COUNCIL OF PHYSIOTHERAPY</li>',
    aa1: 'Appreciation Award at PHYSIOCONNECT- 5, Sharda University.',
    aa2: 'Rising Clinical Performance Award- KRMU PhysioCon 2.0',
    aa3: 'Academic Excellence Award at IMPULSE Jaipur, Vivekanand Global University.',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/physio/kishan.jpg',
    name: 'Dr. Kishan Singh(PT)',
    position: 'Assistant Professor',
    email: 'kishan.singh@mvn.edu.in',
    gs: '',
    linkedin: 'https://www.linkedin.com/in/dr-krishan-sejwar-4378781a1/?trk=eml-email_pymk_02-header-0-profile_glimmer',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'Sports rehab. and musculoskeletal injuries',
    education: 'MPT (Musculoskeletal)',
    re: '1.2',
    te: '2',
    iece: '3.5',
    articles: '1',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: '<li>REGISTERED IN HARYANA STATE COUNCIL OF PHYSIOTHERAPY</li>',
    aa1: '    Appreciation Award at PHYSIOCONNECT- 5, AIPL- Manav Rachna University.',
    aa2: '    Clinical Performance Award- Bhagwan Mahavir hospital, Jain Trust (Physiotherapy Day)',
    aa3: '    Team Sports Physiotherapist - IVPL (National Tournament)',
    aa4: '    Sports Physiotherapist - Badminton Tournament (District level)',
    aa5: '    Sports Physiotherapist- Inter University tournaments (University level)',
    aa6: '    Academic Excellence Award at IMPULSE Jaipur, Vivekanand Global University.'
  },
  
  {
    img: '/assets/img/SAHS/faculty/physio/nikita.jpg',
    name: 'Dr Nitika Roy (PT)',
    position: 'Assistant Professor',
    email: 'nitika.roy@mvn.edu.in',
    gs: '',
    linkedin: '',
    orcid: '0009-0004-4727-214X',
    rg: '',
    website: '',
    aoi: 'Neuroplasticity, Artificial intelligence, Frailty ',
    education: 'MPT Neurology ',
    re: '3+',
    te: '2+',
    iece: '2+',
    articles: '2',
    books: 'N/A',
    chapters: 'N/A',
    patents: '2 Patent & 1 Copyright ',
    membership: 'N/A',
    aa1: '3 Awards in outstanding contribution in the field of Physiotherapy ',
    aa2: '',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/physio/siwas_new.jpg',
    name: 'Dr. Shweta siwas (PT)',
    position: 'Assistant Professor',
    email: 'Shweta.siwas@mvn.edu.in',
    gs: '',
    linkedin: 'https://www.linkedin.com/in/shweta-siwas-b3a290263?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'SPORTS MEDICINE AND REHABILITATION ',
    education: 'BPT , MPT (SPORTS)',
    re: '',
    te: '1year 6months',
    iece: '2+ year',
    articles: '0',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: '<li> Registered in haryana state Council of physiotherapy  </li><li>District President (Mathura) at IPMA  </li>',
    aa1: 'awarded as best academic excellence at IMPULSE SPORTS REHABCON jaipur ',
    aa2: '',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/Ravi_Shankar.jpg',
    name: 'Mr. Ravi Shankar',
    position: 'Assistant Professor',
    email: 'ravi.shankar@mvn.edu.in',
    gs: '',
    linkedin: '',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'Invasive Cardiovascular Techniques, Interventional Cardiology',
    education: 'Msc. Cardiovascular technology',
    re: '2',
    te: '4',
    iece: '2',
    articles: '0',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: 'N/A',
    aa1: 'N/A',
    aa2: '',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/Priya_Garg_PT.jpg',
    name: 'Dr Priya Garg (PT)',
    position: 'Assistant Professor',
    email: 'priya.garg@mvn.edu.in',
    gs: '',
    linkedin: 'https://www.linkedin.com/in/priya-garg-2b76ba251',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'Rehabilitation of Neurological Conditions, Artificial intelligence ',
    education: 'MPT (Neurology)',
    re: '2+',
    te: '1+',
    iece: '3',
    articles: 'N/A',
    books: 'N/A',
    chapters: 'N/A',
    patents: '1',
    membership: 'N/A',
    aa1: 'N/A',
    aa2: '',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/lalita_PT.jpg',
    name: 'Dr. Lalita Dalal (PT)',
    position: 'Assistant Professor',
    email: 'lalita.dalal@mvn.edu.in',
    gs: '',
    linkedin: 'https://www.linkedin.com/in/dr-lalita-dalal-4a9bb630a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'Musculoskeletal Rehabilitation, Multimodal physiotherapy,  ',
    education: 'BPT,MPT(Musculoskeletal), PhD. (pursuing)',
    re: '1',
    te: '6 months',
    iece: '6 months',
    articles: '2',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: 'N/A',
    aa1: 'Have completed international certification of “ ISTMT” .',
    aa2: 'Have completed national and international workshops on skills like Tapping, Dry Needling and Cupping Therapy.',
    aa3: 'Have attended 5 national and international conferences. and 	Successfully completed Research projects on  Effect of Static Stretching on the Strength of calf Muscles And Effect of  static stretching, dynamic stretching, chronic stretching and acute stretching on strength of a muscle and flexibility',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/Yogesh_Kaushik.jpg',
    name: 'Mr. Yogesh Kaushik',
    position: 'Assistant Professor',
    email: 'yogesh.cvt@mvn.edu.in',
    gs: '',
    linkedin: '',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'Non-Invasive Cardiovascular Techniques, Interventional Cardiology',
    education: 'Msc. Cardiovascular technology',
    re: '2',
    te: '3',
    iece: '1',
    articles: '0',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: 'N/A',
    aa1: 'N/A',
    aa2: '',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/physio/r_inki.jpg',
    name: 'Dr. Rinki Singh (PT)',
    position: 'Assistant Professor',
    email: 'rinki.bpt@mvn.edu.in',
    gs: '',
    linkedin: '',
    orcid: '0009-0001-2622-7049',
    rg: '',
    website: '',
    aoi: 'Cardiac & pulmonary rehabilitation ',
    education: 'BPt, MPT( Cardipulmomary)',
    re: '1',
    te: '',
    iece: '6 months',
    articles: '3',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: 'N/A',
    aa1: 'Have completed international certification of “ ISTMT” . ',
    aa2: 'Have completed national and international workshops on skills like Tapping, Dry Needling, Integrated approach for Sport injury and Neural mobilization.',
    aa3: 'Have attended 3 national and international conferences. and 	Successfully completed Research projects on “ Comparision of the effect of inspiratory Muscle training and incentive spirometer in asthmatic patients”. Comparison of myofascial release technique and ISTM on TA pain in Runners"',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/dr_sharki_rawat.jpg',
    name: 'Dr. Sharki Rawat (PT)',
    position: 'Assistant Professor',
    email: 'sharki.rawat@mvn.edu.in',
    gs: '',
    linkedin: '',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'Neurology and its Rehablitation ',
    education: 'MPT(Neurology)',
    re: '',
    te: '1.6',
    iece: '',
    articles: '3',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: 'N/A',
    aa1: '',
    aa2: '',
    aa3: ' ',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/atul_kumar.jpg',
    name: 'Mr. Atul kumar',
    position: 'Assistant Professor',
    email: 'atul.kumar@mvn.edu.in',
    gs: '',
    linkedin: 'https://www.linkedin.com/in/atul-kumar-490444257?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'Medical Microbiology',
    education: 'B.Sc. MLT, MMLS-MM',
    re: '',
    te: '2',
    iece: '',
    articles: 'N/A',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: 'N/A',
    aa1: 'ALMA STAR AWARD 2025',
    aa2: '',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/Sheetal.jpg',
    name: 'Ms. Sheetal Bhalla',
    position: 'Demonstrator',
    email: 'sheetal.bholla@mvn.edu.in',
    gs: '',
    linkedin: '',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'Biotechnlogy',
    education: 'M.Sc (Biotechnology)',
    re: '',
    te: '3+',
    iece: '',
    articles: 'N/A',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: 'N/A',
    aa1: 'N/A',
    aa2: '',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/biotech/priya.jpg',
    name: 'Ms. Priya kumari',
    position: 'Demonstrator',
    email: 'priya.kumari@mvn.edu.in',
    gs: '',
    linkedin: '',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'Hematology, Histopathology',
    education: 'BMLT, M.Sc (MLT)',
    re: '',
    te: '2',
    iece: '',
    articles: 'N/A',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: 'N/A',
    aa1: 'N/A',
    aa2: '',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/biotech/darshan.jpg',
    name: 'Mr. Darshan Payla',
    position: 'Demonstrator',
    email: 'darshan.payla@mvn.edu.in',
    gs: '',
    linkedin: 'https://www.linkedin.com/in/darshanpayla',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'Microbiology, Advance Biochemistry, Bacteriology ',
    education: 'B.Sc, M.Sc (Microbiology)',
    re: '',
    te: '2',
    iece: '',
    articles: 'N/A',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: 'N/A',
    aa1: 'N/A',
    aa2: '',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/physio/bitoo_img.jpg',
    name: 'Dr. Bitoo (PT)',
    position: 'Demonstrator',
    email: 'bittoo.ahs@mvn.edu.in',
    gs: '',
    linkedin: '',
    orcid: '',
    rg: '',
    website: '',
    aoi: '',
    education: 'BPT ',
    re: '',
    te: '',
    iece: '',
    articles: 'N/A',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: 'N/A',
    aa1: 'N/A',
    aa2: '',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/Khushboo_PT.jpg',
    name: 'Dr. Khushboo (PT)',
    position: 'Demostrator',
    email: 'khushboo.sharma@mvn.edu.in',
    gs: '',
    linkedin: '',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'BPT, MPT (Neurology)',
    education: 'BPT, MPT (Neurology)',
    re: '1 year Research experience',
    te: '2 year Clinical experience',
    iece: ' ',
    articles: 'N/A',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: 'N/A',
    aa1: 'N/A',
    aa2: '',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  },
  {
    img: '/assets/img/SAHS/faculty/dr_anjali_chauhan.jpg',
    name: 'Dr. Anjali Chauhan (PT)',
    position: 'Demostrator',
    email: 'anjali.chauhan@mvn.edu.in',
    gs: '',
    linkedin: '',
    orcid: '',
    rg: '',
    website: '',
    aoi: 'Ortho and its conditions',
    education: 'BPT',
    re: '',
    te: '',
    iece: '',
    articles: 'N/A',
    books: 'N/A',
    chapters: 'N/A',
    patents: 'N/A',
    membership: 'N/A',
    aa1: 'N/A',
    aa2: '',
    aa3: '',
    aa4: '',
    aa5: '',
    aa6: ''
  }
      

    ]
   
return(
    <Grid container spacing={2} sx={{margin:'10px 0px'}}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
            <MainTitle title='School of Allied Health Sciences Faculties'/>
        </Grid>
         
        {facultyList?.map((fac)=>(
        <Grid item xs={12} sm={12} md={4} lg={4}>
            <FacultyCard faculty={fac} />
        </Grid>
        ))}
         <br/><br/>
    </Grid>
)
}
export default FacultyList;